import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import useAuthStore from '../../store/authStore';

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, user, token, validateToken, handleTokenExpiry } = useAuthStore();
  const location = useLocation();
  const [isValidating, setIsValidating] = useState(true);
  const [isValid, setIsValid] = useState(false);

  useEffect(() => {
    const checkAuthStatus = async () => {
      try {
        // 기본 인증 상태 확인
        if (!isAuthenticated || !user || !token) {
          console.log('[PROTECTED_ROUTE]', 'No authentication data found');
          setIsValidating(false);
          setIsValid(false);
          return;
        }

        // 토큰 유효성 검사
        const tokenIsValid = await validateToken();
        if (!tokenIsValid) {
          console.log('[PROTECTED_ROUTE]', 'Token validation failed');
          handleTokenExpiry();
          setIsValidating(false);
          setIsValid(false);
          return;
        }

        console.log('[PROTECTED_ROUTE]', 'Authentication valid for user:', user.name);
        setIsValidating(false);
        setIsValid(true);

      } catch (error) {
        console.error('[PROTECTED_ROUTE]', 'Auth validation error:', error);
        handleTokenExpiry();
        setIsValidating(false);
        setIsValid(false);
      }
    };

    checkAuthStatus();
  }, [isAuthenticated, user, token, validateToken, handleTokenExpiry]);

  // 로딩 중일 때 표시할 컴포넌트
  if (isValidating) {
    return (
      <div style={{
        width: '100%',
        height: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: '#f5f5f5',
        fontFamily: 'Inter, sans-serif'
      }}>
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: '16px'
        }}>
          <div style={{
            width: '32px',
            height: '32px',
            border: '3px solid #e5e7eb',
            borderTop: '3px solid #6A42F2',
            borderRadius: '50%',
            animation: 'spin 1s linear infinite'
          }}></div>
          <p style={{
            color: '#666666',
            fontSize: '16px',
            margin: 0
          }}>
            인증 확인 중...
          </p>
        </div>
      </div>
    );
  }

  // 인증 실패시 로그인 페이지로 리다이렉트
  if (!isValid) {
    console.log('[PROTECTED_ROUTE]', 'Redirecting to login from:', location.pathname);
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // 인증 성공시 자식 컴포넌트 렌더링
  return children;
};

export default ProtectedRoute;